import React, { createContext, useContext, useState, useCallback } from "react";
import ToastItem from "./ToastItem"; 
import { v4 as uuidv4 } from "uuid";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback(({ title, description = "", type = "info", duration = 4000 }) => {
    const id = uuidv4();
    setToasts((prev) => [...prev, { id, title, description, type, duration }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="fixed top-5 right-5 z-50 space-y-2">
        {toasts.map((toast) => (
          <ToastItem key={toast.id} {...toast} />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
